import requester from '@/lib/axios';
import Evaluation, { EvaluationTypeEnum } from '@/models/Evaluation';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';

export interface EvaluationFilter extends BaseFilters {
  courseLineId?: number;
  coursePathId?: number;
  type?: EvaluationTypeEnum;
  isDefault?: boolean;
  sourceTemplateId?: number;
  sourceTemplateIds?: number[];
}

const baseUrl = 'evaluations';

export const listEvaluations = async (params: EvaluationFilter = {}) => {
  const { data } = await requester().get<JsonApiResponse<Evaluation>>(
    `${baseUrl}/`,
    { params },
  );
  return data;
};

export const createEvaluation = async (body: Partial<Evaluation>) => {
  const { data } = await requester().post<Evaluation>(`${baseUrl}/`, body);
  return data;
};

export const updateEvaluation = async (
  evaluationId: number,
  body: Partial<Evaluation>,
) => {
  const { data } = await requester().patch<Evaluation>(
    `${baseUrl}/${evaluationId}/`,
    body,
  );
  return data;
};

export const deleteEvaluation = async (evaluationId: number) => {
  await requester().delete<void>(`${baseUrl}/${evaluationId}/`);
};

export const applyTemplate = async (body: {
  templateId: number;
  coursePathId: number;
}) => {
  const { data } = await requester().post<Evaluation>(
    `${baseUrl}/apply-template/`,
    body,
  );
  return data;
};

export const propagateTemplate = async (body: { templateId: number }) => {
  const { data } = await requester().post<Evaluation[]>(
    `${baseUrl}/propagate-template/`,
    body,
  );
  return data;
};
